import React, { useCallback, useEffect, useState } from "react";

import Table from "../../components/table/Table";
import { employee } from "./content";

import CustomPopup from "../../components/CustomPopup/CustomPopup";
import { Col, Row } from "react-bootstrap";
import CustomInput from "../../components/common/Input/Input";
import { Controller, useForm } from "react-hook-form";
import CustomSelect from "../../components/common/Select/Select";
import { ReactComponent as Trash } from "../../assets/images/delete_icon.svg";
import { ReactComponent as Edit } from "../../assets/images/edit.svg";
import { api } from "../../api/api";
import { useAuthContext } from "../../ContextAPI/AuthContextAPI";
import moment from "moment";
import { debounce } from "lodash";

const Category = () => {
  const { doLogin, currUserData } = useAuthContext();

  const [popupShow, setPopupShow] = useState(false);
  const [data, setData] = useState(employee);
  const [editData, setEditData] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const [totalCount, setTotalCount] = useState(1);

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const {
    register,
    control,
    reset,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const handleDelete = async (rowIndex, id) => {
    let res = await api(
      `api/v1/category/deleteCategory/${id}`,
      {},
      "delete",
      currUserData?.token,
      ""
    );
    if (res && res.success) {
      // setSubscriptionData(res?.data);
      console.log(res, "delete");
      getCategory();
      // setData(res.faqs);
      // setIsLoading(false);
    }
  };
  console.log(editData._id, "editData editData ");
  const handleEdit = async (original) => {
    console.log(original, "jdjdj");
    setPopupShow(true);

    setEditData(original);
    const fields = ["name", "description"];

    fields.forEach((field) => setValue(field, original[field]));

    // setValue("gender", { label: "Female", value: "Female" });
  };

  const handelSearch = (event) => {
    debouncedSearch(event.target.value);
  };

  const debouncedSearch = useCallback(
    debounce((term) => {
      // Call your search API here
      getCategory(term);
      console.log("Searching for:", term);
    }, 500), // Adjust debounce time (in milliseconds)
    []
  );

  const registerOptions = {
    name: {
      required: "Category name is required",
      pattern: {
        value: /^[a-zA-Z0-9]+(?: [a-zA-Z0-9]+)*$/,
        message:
          "Only letters, numbers, and spaces are allowed (no special characters)",
      },
    },
    email: {
      required: "Email is required",
      pattern: {
        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        message: "Enter a valid email address",
      },
    },
    phone: {
      required: "Phone Number is required",
      pattern: {
        value: /^[0-9]{10}$/, // Ensures exactly 10 digits
        message: "Enter a valid 10-digit phone number",
      },
    },
  };
  const AddCategory = async (data) => {
    console.log(data, "form sdf");

    var payload = {
      name: data.name,
      description: data.description,
    };
    const editPayload = {
      name: data.name,
      description: data.description,
    };
    console.log(editData, " editData ");
    if (editData) {
      let res = await api(
        `api/v1/category/updateCategory/${editData._id}`,
        editPayload,
        "put",
        currUserData.token,
        ""
      );
      if (res && res.success) {
        // setSubscriptionData(res?.data);
        setPopupShow(false);
        reset();
        getCategory();
      }
    } else {
      let res = await api(
        `api/v1/category/addCategory`,
        payload,
        "post",
        currUserData.token,
        ""
      );
      if (res && res.success) {
        // setSubscriptionData(res?.data);
        setPopupShow(false);
        reset();
        getCategory();
      }
    }
    reset();
    setEditData("");
  };

  const getCategory = async (term = "") => {
    setIsLoading(true);
    let res = await api(
      `api/v1/category/getCategories?page=${
        pageIndex + 1
      }&limit=${pageSize}&search=${term}`,
      "",
      "get",
      currUserData?.token,
      ""
    );
    if (res && res.success) {
      console.log(res, "res resgetCategorygetCategorygetCategory");
      setData(res?.data);
      setIsLoading(false);
      setTotalCount(res?.pagination?.totalItems);
    }
  };

  const handleToggleStatus = (rowIndex) => {
    const newData = [...data];
    newData[rowIndex].status = !newData[rowIndex].status;
    setData(newData);
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Category Name",
        accessor: "name",
      },
      {
        Header: "Description",
        accessor: "description",
      },

      {
        Header: "Created On",
        accessor: "createdAt",
        Cell: ({ row }) =>
          moment(row.original.createdAt, "YYYY-MM-DD").format("DD-MM-YYYY"),
      },

      {
        Header: "Action",
        accessor: "",
        Cell: ({ row }) => (
          <div class="dropdown">
            <span
              data-bs-toggle="dropdown"
              style={{ cursor: "pointer" }}
              aria-expanded="false"
            >
              <i class="fas fa-ellipsis-v"></i>
            </span>
            <ul class="dropdown-menu">
              <li>
                <span
                  className="me-3 cursor-pointer"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    handleEdit(row.original);
                  }}
                >
                  {/* <Edit />  */}
                  Edit
                </span>
              </li>
              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => handleDelete(row.index, row.original._id)}
                >
                  {/* <Trash /> */}
                  Delete
                </span>
              </li>
            </ul>
          </div>
        ),
      },
    ],
    []
  );

  useEffect(() => {
    getCategory();
  }, [pageIndex, pageSize]);

  return (
    <>
      <div className="employee_management">
        <div className="p-40">
          <div className="page_heading mb-4">
            <div>
              <p className="heading">Category</p>
            </div>
            <button
              className="btn_primary"
              onClick={() => setPopupShow(!popupShow)}
            >
              + Add Category
            </button>
          </div>

          <div className="employee_list ">
            <Table
              columns={columns}
              data={data}
              onEdit={handleEdit}
              onDelete={handleDelete}
              onToggleStatus={handleToggleStatus}
              onSearch={handelSearch}
              isLoading={isLoading}
              totalCount={totalCount}
              pageIndex={pageIndex}
              pageSize={pageSize}
              setPageIndex={setPageIndex}
              setPageSize={setPageSize}
            />
          </div>
        </div>
      </div>

      <CustomPopup
        show={popupShow}
        close={setPopupShow}
        closeIcon={true}
        id="Add Category"
        title="Add Category"
        bg={false}
        width="lg"
      >
        <form className="w-100  p-5" onSubmit={handleSubmit(AddCategory)}>
          <Row>
            <Col md="12">
              <CustomInput
                register={register}
                label="Category Name"
                name="name"
                placeholder="e.g., SSC"
                type="text"
                errors={errors.name}
                validation={registerOptions.name}
                onInput={(e) => {
                  // Replace anything that is not a letter, number or space
                  e.target.value = e.target.value.replace(/[^a-zA-Z0-9 ]/g, "");
                }}
              />
            </Col>
            <Col md="12">
              <label class="input_lable">Description</label>
              <textarea
                id="description"
                name="description"
                {...register("description", registerOptions.description)}
                rows="4"
                cols="50"
                maxlength="200"
                className="custom_input"
                placeholder="Description"
              ></textarea>
            </Col>
          </Row>
          <button
            className="mx-auto d-block btn_primary w-100 mb-5 mt-5" // onClick={() => navigate("/dashboard")}
          >
            Submit
          </button>
        </form>
      </CustomPopup>
    </>
  );
};

export default Category;
